import React from 'react';
import { Route, Switch } from 'react-router';
import Layout from 'components/Layout';
import List from './List';
import Form from './Form';

const Video = () => (
  <Layout>
    <Switch>
      <Route exact path="/videos" component={List} />
      <Route exact path="/videos/new" component={Form} />
      <Route exact path="/videos/:id" component={Form} />
    </Switch>
  </Layout>
);

export default Video;
